import styled from 'styled-components';
import { Button, Modal } from 'antd';
import * as palette from '../../styles/variables';
export const Container = styled.div`
  height: 100%;
  position: relative;
  padding-left: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
`;

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SettingpageConatiner = styled.div`
  max-width: ${props => (props.isEmailAudit ? '100%' : props.isMailRoom ? '100vw' : '1400px')};
  width: 100%;
  margin-left: 4%;
  height: 100%;
  display: flex;
  align-items: center;
  background: ${props => props.isMailRoom && '#f1f3f4'};
  padding: ${props => (props.isMailRoom ? '0px' : '15px 0px')};
  .popOverConfirm {
    padding: 10px !important;
  }
  .ant-popover-inner-content {
    .ant-popover-message-title {
      padding-left: 7px !important;
      padding-right: 20px !important;
    }
    .ant-popover-buttons {
      margin-bottom: 7px !important;
      text-align: center !important;
      padding: 5px !important;
    }
  }
`;

export const UserConatiner = styled.div`
  max-width: 1400px;
  width: 100%;
`;

export const Detailwrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-left: ${props => (props.isMailRoom ? '0' : '4rem')};
  @media (max-width: 1024px) {
    padding-left: ${props => (props.isMailRoom ? '0' : '1rem')};
  }
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: ${props => !props.isMailRoom && 'auto'};
  .ant-alert-with-description .ant-alert-close-icon {
    top: 13px;
  }
  .alert-error {
    width: 90% !important;
    padding: 10px !important;
  }
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const SearchBar = styled.div`
  border: 1px solid rgb(185, 185, 185);
  background-color: #ffffff;
  width: 70%;
  display: flex;
  border-radius: 50px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;

input {
  width: 95%;
  border: none;
  outline: none;
  padding-right: 10px;
}

.icon {
  width: 5%;
  text-align: center;
  cursor:pointer;
  font-size: 24px;
}

`

export const DetailCardContainer = styled.div`
  width: 90%;
  @media (max-width: 1024px) {
    width: 94%;
  }
  .anticon-right,
  .ant-collapse-arrow {
  }
  .ant-collapse-item {
    border: none !important;
  }
  .ant-collapse-header {
    border-radius: 0;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
  }
  .editContainer {
    position: absolute;
    right: 6%;
    top: 23px;
    .anticon {
      font-size: 17px;
      color: #000;
      margin: 0px 10px;
      padding: 0px 5px;
    }
  }
  .collapse-card-style {
    display: flex;
    flex: initial;
    flex-direction: column;
    padding: 10px;
    border-radius: 6px;
    border-bottom: 1px solid rgb(223, 225, 228);
    box-shadow: rgb(0 0 0 / 3%) 0px 2px 5px;
    background-color: #ffffff;
    flex-basis: 31%;
    margin: 15px 15px 15px 0px;
    p {
      font-size: 13px;
      font-weight: 400;
    }
    .heading-txt {
      color: rgb(40, 42, 48);
      font-weight: 600;
      font-size: 15px;
      padding-right: 5px;
      line-height: 26px;
    }
    &:hover {
      box-shadow: rgb(0 0 0 / 9%) 0px 3px 12px;
    }
  }
  .ant-table-thead > tr > th .ant-table-header-column{
    min-width: 52px;
  }
`;

export const DetailHeadingCover = styled.div`
  display: flex;
  width: ${props =>
    props.separator || props.isMailRoom ? '100%' : props.isEmailAudit ? '95%' : '90%'};
  @media (max-width: 1024px) {
    width: ${props =>
    props.separator || props.isMailRoom ? '100%' : props.isEmailAudit ? '95%' : '94%'};
  }
  align-items: center;
  justify-content: space-between;
  background: ${props => props.isMailRoom && '#fff'};
  height: ${props => props.isMailRoom && '80px'};
  padding: ${props =>
    props.separator
      ? '25px 0px 0px 0px'
      : props.isEmailAudit
      ? '15px 0px'
      : props.isMailRoom
      ? '12px 30px'
      : '25px 0px'};
  border-bottom: ${props => props.isMailRoom && '2px solid #e9e9e9'};
  // z-index: ${props => props.isMailRoom && '500'};
  margin-left: ${props => props.isMailRoom && '14px'};

  h5 {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: 32px;
    text-transform: uppercase;
  }
  p {
    font-size: 13px;
    color: #afafaf;
    margin-top: 5px;
    width: ${props => !props.isMailRoom && '700px'};
  }
  .mailRoomDesc {
    letter-spacing: 0.5px;
  }
  .ant-input-affix-wrapper {
    width: ${props => props.isMailRoom && '30%'};
  }
  .titlSec {
    width: 50%;
  }
  .totalSelected {
    width: 50%;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    opacity:${props => !props.isDocSelected && '0'}
  }
  .searchContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 30%;
    .ant-input-affix-wrapper {
      width: 100%;
    }
    .searchAdvSearch{
      display: flex;
      flex-direction: column;
      width: 85%;
      align-items: center;
      justify-content: center;
      height: 55px;
      z-index: 1000;
    }
    .advSearch {
      font-size: 11px;
      width: 140px;
      margin: 0;
      color: #000;
      cursor: pointer;      
      width: 100%;
      text-align: right;
      text-decoration: underline;
      &:hover{
        text-decoration: none;
      }
      i.anticon.anticon-close-circle {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }
  .selectedIcon {
    position: relative;
    cursor: pointer;
    z-index: 1000;
    width: 15%;
  }
  .selectedCount {
    top: -15px;
    position: absolute;
    left: 20px;
    background: red;
    color: #fff;
    width: 18px;
    height: 18px;
    text-align: center;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const CountTile = styled.div`
  h5 {
    font-weight: 600;
    font-size: 14px;
  }
  p {
    font-size: 11px !important;
    color: #afafaf;
    width: 150px;
    @media (max-width: 1024px) {
      width: 72px;
    }
    text-transform: initial;
  }
`;

export const CreateButton = styled(Button)`
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  height: 35px;
  margin-left: ${props => (props.isMailRoom && '15px')};
  margin-top: ${props => (props.isMailRoom && '5px')};
  padding: 10px 20px;
  display: flex;
  align-items: center;
  background: ${props => (props.createEntity ? '#000' : palette.APP_BRAND_YELLOW_COLOR)};
  border-radius: 20px;
  color: ${props => (props.createEntity ? '#fff' : '#000')};
  text-shadow: none;
  border: 2px solid transparent;
  &:hover,
  &:focus {
    background: ${props => (props.createEntity ? '#000' : palette.APP_BRAND_YELLOW_COLOR)};
    color: ${props => (props.createEntity ? '#fff' : '#000')};
    border-color: transparent;
    box-shadow: initial;
  }
`;

export const TableContainer = styled.div`
  padding: 10px 0px;
  @media (max-width: 1024px) {
    overflow-x: auto;
  }
  .ant-table-thead > tr > th {
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
  }
  .varActions {
    text-decoration: underline;
    color: #000;
    font-weight: 600;
    cursor: pointer;
  }
  ////////////   table-pagination /////////
  .ant-table-pagination.ant-pagination {
    float: none;
    margin: 16px 0;
    text-align: center;
  }
  .ant-pagination-item a {
    text-decoration: none;
    transition: none;
  }
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: #000;
  }
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: #000;
  }
  .ant-pagination-item-active,
  .ant-pagination-item-active:hover,
  .ant-pagination-item-active:focus {
    font-weight: 500;
    background: #000;
    border-color: #000;
  }
  .ant-pagination-item-active a,
  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a {
    color: #fff;
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #000;
    border-color: #000;
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled,
  .ant-pagination-disabled:hover,
  .ant-pagination-disabled:focus {
    color: rgba(0, 0, 0, 0.25) !important;
    border-color: #d9d9d9 !important;
    cursor: not-allowed;
  }

  //////  checkBox   /////

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #000;
    border-color: #000;
  }
  .ant-checkbox-checked::after {
    border: 1px solid #000;
    border-radius: 2px;
  }
  .ant-checkbox-input:hover + .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #000;
  }
  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #f5f5f5;
  }
`;

export const PopupContainer = styled.div`
  min-width: 240px;
  max-width: 250px;
  padding: 15px;
  position: relative;
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
  }
  .ant-input:placeholder-shown {
    font-size: 12px;
    font-weight: normal;
  }
  p {
    font-size: 14px;
    font-weight: 600;
    padding: 0px;
    margin: 0px;
  }
`;

export const PopupActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: center;
`;

export const PopupLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
`;

export const WarningLabel = styled.div`
  color: #f5222d;
  font-size: 14px;
`;

export const CancelButton = styled(Button)`
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: #000;
  border-radius: 4px;
  color: #fff;
  border: 1px solid transparent;
  margin-right: 10px;
  font-weight: 500;
  text-transform: uppercase;
  height: 35px;
  padding: 10px 20px;
  border-radius: 20px;
  &:hover,
  &:focus {
    background: #000;
    color: #fff;
    border: 1px solid transparent;
    box-shadow: initial;
  }
`;
export const SearchContainer = styled.div`
  .ant-btn-primary,
  .ant-btn,
  .ant-btn:active,
  .ant-btn:focus {
    color: #fff;
    background-color: #000;
    border-color: #000;
    font-size: 12px;
    height: 30px;
    border-radius: 50px;
  }
  .searchInput {
    margin-bottom: 15px !important;
  }
`;

export const ReadableCommaDiv = styled.div`
  display: inline;
  div {
    display: inline;
  }
  div:not(:last-of-type)::after {
    content: ', ';
    white-space: pre;
  }
`;

export const ModalContainerDiv = styled(Modal)`
.ant-modal-content {
  width: 500px;
  height: 260px;
  .ant-modal-close-x .ant-modal-close-icon {
    color: white;
  }
  .ant-modal-header {
    background-color: black;
    padding: 16px 34px !important;
    h4 {
      color: white;
    }
  }
  .delete-entity {
    display: none;
    color: red;
    &:hover {
      display: block;
    }
  }
}
`

export const RelationContainer = styled.div`
  display: flex;
  gap: 2px;
  flex-wrap: wrap;
`

export const RelatedEntityCard = styled.div`
  position: relative;
  width: 130px;
  padding: 20px;
  border-radius: 15px;
  text-align: center;
  margin: 15px;
  box-sizing: border-box;
  display: inline-block;
  .has-label {
    background-color: black;
    color: white;
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 8px;
    display: inline-block;
    margin-bottom: -15px;
  }
  .entity-type {
    width: 90px;
    font-size: 60px;
    font-weight: 900;
    color: #4b4b4b;
    margin-bottom: 14px;
    background-color: ${props => (props.isArray ? '#D8D0F4' : '#D8F4C9')};
    border-radius: 14px;
  }
  .title {
    font-size: 14px;
    color: #222;
    text-transform: uppercase;
    width: 90px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .delete-relation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 10px;
    font-size: 44px;
    color: white;
    cursor: pointer;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    .anticon.anticon-delete{
      display: none;
    }

    
  }
  .delete-entity-modal {
    .ant-modal-footer {
      height: 200px !important;
    }
  }
  .delete-relation:hover {
    background-color: rgba(0, 0, 0, 0.4);
    .anticon.anticon-delete {
      display: block;
    }
  }
`

export const DeleteRelationshipModal = styled(Modal)`
.ant-modal-content {
  width: 500px;
  height: ${props => (props.height || '220px')};
  margin-top: 120px;
  .ant-modal-close-x .ant-modal-close-icon {
    color: #333;
  }
  .ant-modal-header {
    background-color: black;
    padding: 16px 34px !important;
    h4 {
      color: white;
    }
  }
  .ant-modal-body {
    padding: 34px 30px 20px !important;
    h4 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .ant-modal-footer {
    text-align: end !important;
    .ant-btn-danger {
      background-color: red !important;
      border: 1px solid black;
    }
  }
  .delete-entity {
    display: none;
    color: red;
    &:hover {
      display: block;
    }
  }
}
`
